import React from 'react';

const CapacityBadge = ({ capacity, label, className = "" }) => {
  return (
    <div className={`inline-flex items-center gap-2 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-lg text-sm font-medium ${className}`}>
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
      </svg>
      <span>{capacity} {label}</span>
    </div>
  );
};

export default CapacityBadge;
